/**
 * 修改URL的查询参数而不刷新页面
 * @param {Object} paramsToUpdate - 要更新的参数对象
 * @param {Object} paramsToDelete - 需要删除的参数
 * @param {boolean} [replace=false] - 是否使用replaceState替代pushState
 * @returns {string} 更新后的URL
 */
function changeUrlParams(paramsToUpdate, paramsToDelete = [], replace = true) {
  try {
    // 获取当前URL参数
    const newParams = new URLSearchParams(window.location.search);

    // 更新参数
    if (paramsToUpdate != null) {
      Object.entries(paramsToUpdate).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') {
          newParams.delete(key); // 删除空值
        } else {
          newParams.set(key, value);
        }
      });
    }

    if (paramsToDelete.length) {
      paramsToDelete.forEach((key) => {
        newParams.delete(key);
      });
    }

    // 构建新URL
    const paramString = newParams.toString();
    const newUrl =
      window.location.pathname + (paramString ? '?' + paramString : '');
    // 更新浏览器历史
    if (replace) {
      history.replaceState(paramsToUpdate, '', newUrl);
    } else {
      history.pushState(paramsToUpdate, '', newUrl);
    }

    // 可选：触发自定义事件，允许组件响应URL变化
    window.dispatchEvent(
      new CustomEvent('url-params-changed', {
        detail: paramsToUpdate,
      })
    );

    return newUrl;
  } catch (error) {
    console.error('Failed to update URL parameters:', error);
    return window.location.href;
  }
}

export default changeUrlParams;
// 使用举例
// 添加或者修改url上的参数
// changeUrlParams({ 'share_id': result.data.share_id })

// 删除url上的参数
// changeUrlParams(null,['share_id'])
